import React, { useState } from 'react';
import { UploadedFile } from '../../stores/csvStore';
import CSVPreview from './CSVPreview';
import './MultiFileCSVPreview.css';

interface MultiFileCSVPreviewProps {
  uploadedFiles: UploadedFile[];
}

const MultiFileCSVPreview: React.FC<MultiFileCSVPreviewProps> = ({ uploadedFiles }) => {
  const [activeFileIndex, setActiveFileIndex] = useState(0);

  if (uploadedFiles.length === 0) {
    return (
      <div className="multi-file-preview">
        <div className="preview-placeholder">
          <div className="placeholder-content">
            <div className="placeholder-icon">📄</div>
            <h3>CSV Preview</h3>
            <p>Upload CSV files to see a preview of your data here</p>
          </div>
        </div>
      </div>
    );
  }

  if (uploadedFiles.length === 1) {
    // Single file - use the original CSVPreview component
    return <CSVPreview file={uploadedFiles[0].csvFile} />;
  }

  // Multiple files - show tabs
  return (
    <div className="multi-file-preview">
      <div className="file-tabs">
        {uploadedFiles.map((file, index) => (
          <button
            key={file.id}
            className={`file-tab ${index === activeFileIndex ? 'active' : ''}`}
            onClick={() => setActiveFileIndex(index)}
            title={file.name}
          >
            <span className="tab-icon">📄</span>
            <span className="tab-name">
              {file.name.length > 15 ? file.name.substring(0, 15) + '...' : file.name}
            </span>
            <span className="tab-info">
              {file.parsedData.rows.length} rows
            </span>
          </button>
        ))}
      </div>
      
      <div className="active-file-preview">
        <CSVPreview file={uploadedFiles[activeFileIndex].csvFile} />
      </div>
    </div>
  );
};

export default MultiFileCSVPreview;

